import { useEffect, useMemo } from 'react';
import { useQueryClient } from 'react-query';

import { ENDPOINT_SCANBAT_CHECKOUT_CONFIRM } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import useWarehouses from '@/common/hooks/warehouses/useWarehouses';
import SessionStorageScanbat from '@/common/services/SessionStorage.scanbat';

const useCheckoutConfirmContainer = () => {
  const { logout } = useAuth();
  const queryClient = useQueryClient();

  const scanbatService = SessionStorageScanbat.getService();

  const {
    data: warehouse,
    isLoading: isLoadingWarehouse,
    isFetching: isFetchingWarehouse,
  } = useWarehouses({
    company: scanbatService.getScanbatCompany(),
    code: scanbatService.getScanbatWarehouse(),
  });

  const isDisabled = useMemo(() => {
    const loading = isLoadingWarehouse || isFetchingWarehouse;

    return {
      disabled: loading,
      loading,
    };
  }, [isFetchingWarehouse, isLoadingWarehouse]);

  const order = useMemo(
    () => queryClient.getQueryData([ENDPOINT_SCANBAT_CHECKOUT_CONFIRM]),
    [queryClient],
  );

  useEffect(() => {
    if (
      !order ||
      !scanbatService.getScanbatCompany() ||
      !scanbatService.getScanbatWarehouse()
    ) {
      scanbatService.clearScanBat();
      logout();
    }
  }, [logout, order, scanbatService]);

  return {
    company: scanbatService.getScanbatCompany(),
    isDisabled,
    order,
    warehouse,
  };
};

export default useCheckoutConfirmContainer;
